import MiniCartDrawer from './MiniCartDrawer';
import MiniCartTrigger from './MiniCartTrigger';
import scrollLock from 'scroll-lock';
import { useCartContext } from '../context/CartContext';
import { useEffect } from 'preact/hooks';
import { Fragment, h } from 'preact';

const MiniCart = () => {
  const { isMiniCartOpen } = useCartContext();

  useEffect(() => {
    if (isMiniCartOpen) {
      document.body.classList.add('minicart-open');
      scrollLock.disablePageScroll();
    } else {
      document.body.classList.remove('minicart-open');
      scrollLock.enablePageScroll();
    }
  }, [isMiniCartOpen]);

  return (
    <Fragment>
      <MiniCartTrigger />
      <MiniCartDrawer />
    </Fragment>
  );
};

export default MiniCart;
